var pt = pt || {};
pt.blocografico = pt.blocografico || {};
pt.blocografico.modules = pt.blocografico.modules || {};
pt.blocografico.modules.homepageModule =
  pt.blocografico.modules.homepageModule || {};
pt.blocografico.modules.homepageModule = (function () {
  function initCarousel(selector) {
    const wrapper = document.querySelector(selector);
    if (!wrapper) return;
    const smooth = wrapper.dataset.smooth !== undefined ? parseInt(wrapper.dataset.smooth, 10) : 0;
    pt.blocografico.library.createCarousel(selector, {
      autoplay: true,
      interval: 2500,
      clickable: true,
      smooth,
    });
  }

  function init() {
    initCarousel("#hero-slider");
    initCarousel("#actions-slider");
  }

  return { init };
})();

document.addEventListener("DOMContentLoaded", function () {
  pt.blocografico.modules.homepageModule.init();
});
